import { useCurrency, type CurrencyCode } from "./CurrencyProvider";

function norm(code: string): CurrencyCode {
  const up = String(code || "CUP")
    .trim()
    .toUpperCase();
  const supported = [
    "USD",
    "EUR",
    "MXN",
    "CAD",
    "CHF",
    "CUP",
    "CLA",
    "MLC",
    "ZELLE",
  ] as const;

  return (supported.includes(up as any) ? up : "CUP") as CurrencyCode;
}

/**
 * Muestra el precio convertido a la moneda preferida SOLO si hay tasas públicas
 * suficientes para convertir. Si no, muestra el precio en la moneda fuente real
 * para no mentir visualmente al usuario.
 */
export function Price({
  cents,
  currency,
}: {
  cents: number;
  currency: string;
}) {
  const { currency: preferred, canConvert, convert, fmt } = useCurrency();

  const from = norm(currency);
  const to = preferred;

  const shouldConvert = canConvert(from, to);
  const displayCurrency = shouldConvert ? to : from;
  const displayCents = shouldConvert ? convert(cents, from, to) : cents;

  return <span>{fmt(displayCents, displayCurrency)}</span>;
}
